import React, { PureComponent } from 'react'
import { View, Image } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../Atoms/Typography'

import theme from '../../../styles/theme'

const source = require('../../../assets/excelerate-logo.png')

const Container = styled(View)`
  flex: 1;
  background-color: ${theme.colours.black};
`

const Body = styled(View)`
  flex: 1;
  padding: ${3 * theme.gutterUnit}px;
  background-color: ${theme.colours.black};
  align-items: center;
  justify-content: center;
`

const Logo = styled(Image)`
  width: 235px;
  height: 120px;
`

class ErrorPage extends PureComponent {
  render () {
    return (
      <Container>
        <Body>
          <Logo source={source} resizeMode='contain' />
          <Text size='xl' white overrides={{ marginTop: theme.gutterUnit * 2 }}>{this.props.error}</Text>
          {!this.props.notRetryable && <Text size='m' white overrides={{ marginTop: theme.gutterUnit * 2 }}>Please try again by reloading the page or by pressing F5</Text>}
        </Body>
      </Container>
    )
  }
}

export default ErrorPage
